import React, { FC } from 'react';
import { IHelloRetailSitePage } from '~/modules/search/interfaces/suggestion';
import { ResultCard } from './result-card';

type Props = {
    store?: IHelloRetailSitePage;
};

export const StoreCard: FC<Props> = ({ store }) => {
    return (
        <ResultCard
            url={store?.originalUrl}
            // teaser={article.teaser}
            // imageSrc={article.image || articles.defaultIconUrl}
            title={store?.title}
            trackingCode={store?.trackingCode}
        />
    );
};
